<div fxLayout="column" class="center-container">

    <!--    Loading message-->
    <div *ngIf="loadingMessage" class="skeleton-card">
        <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center">

            <div fxLayout="column" fxFlex="5">
                <ngx-skeleton-loader
                        count="1"
                        appearance="circle"
                        animation="progress"
                        [theme]="{ width: '24px', height: '24px', 'border-radius': '50%' }"
                >
                </ngx-skeleton-loader>
            </div>
            <div fxLayout="column" fxFlex="65">
                <div fxLayout="row" fxFlex="grow">
                    <ngx-skeleton-loader fxFlex="40" count="1" animation="progress-dark"
                                         [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
                </div>
                <div fxLayout="row" fxFlex="grow">
                    <ngx-skeleton-loader fxFlex="100" count="1" animation="progress-dark"
                                         [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
                </div>
            </div>
            <div fxLayout="column" fxFlex="30" fxLayoutAlign="center center center">
                <div fxLayout="row" fxLayoutGap="10px">

                    <div fxLayout="column">
                        <ngx-skeleton-loader
                                count="1"
                                appearance="circle"
                                animation="progress"
                                [theme]="{ width: '98px', height: '36px', 'border-radius': '15px' }"
                        >
                        </ngx-skeleton-loader>
                    </div>
                    <div fxLayout="column">
                        <ngx-skeleton-loader
                                count="1"
                                appearance="circle"
                                animation="progress"
                                [theme]="{ width: '98px', height: '36px', 'border-radius': '15px' }"
                        >
                        </ngx-skeleton-loader>
                    </div>

                </div>
            </div>


        </div>
    </div>
    <div *ngIf="messageVisible && !loadingMessage" fxLayout="column"
         ngStyle.lt-md="padding-left:15px; padding-right:15px;">
        <app-notification-message [currentUser]="user" [message]="message"
                                  (closeMessage)="checkMessageVisibility($event)"></app-notification-message>
    </div>


    <!-- Section Header - Modern Minimal Design -->
    <div class="section-header">
        <div class="section-header-icon">
            <mat-icon>description</mat-icon>
        </div>
        <span class="section-header-title">Οι διαθέσιμες δηλώσεις μου</span>
        <div class="section-header-line"></div>
    </div>

    <div *ngIf="!loadingChildren">
        <div *ngFor="let entry of selectedChildren" style="margin-bottom: 10px;">
            <div fxLayout="column" fxFlex="grow">
                <!-- All notifications combined (current + past years) -->
                <app-student-form-cards [child]="entry" [user]="user"
                    [notifications]="(entry.currentYearNotifications || []).concat(entry.pastYearNotifications || [])">
                </app-student-form-cards>
            </div>
        </div>

        <!-- Empty state when no declarations available -->
        <div *ngIf="selectedChildren?.length === 0" class="no-declarations">
            <mat-icon>description_outlined</mat-icon>
            <span>Δεν υπάρχουν διαθέσιμες δηλώσεις</span>
        </div>
    </div>

    <div *ngIf="loadingChildren" class="skeleton-card">
        <div fxLayout="column" fxFlex="grow">
            <div fxLayout="row" fxFlex="grow">
                <ngx-skeleton-loader fxFlex="30" count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
            <div fxLayout="row" fxFlex="grow">
                <ngx-skeleton-loader fxFlex count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
            <div fxLayout="row" fxFlex="grow">
                <ngx-skeleton-loader fxFlex="grow" count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
        </div>
    </div>

    <!-- Public Forms Section -->
    <div *ngIf="publicForms.length > 0" class="section-header" style="margin-top: 20px;">
        <div class="section-header-icon">
            <mat-icon>public</mat-icon>
        </div>
        <span class="section-header-title">Δημόσιες δηλώσεις</span>
        <div class="section-header-line"></div>
    </div>

    <div *ngIf="publicForms.length > 0" fxLayout="row wrap" fxFlex="grow" fxLayoutGap="15px"
         style="overflow-y: auto; max-height: 400px; margin-bottom: 10px;">
        <div class="public-form-card" *ngFor="let form of publicForms">

            <div class="public-form-header">
                <mat-card-title [matTooltip]="form.title" class="public-form-title">
                    {{ form.title | slice:0:60 }}{{form.title.length > 60 ? '...' : ''}}
                </mat-card-title>
                <mat-card-subtitle class="public-form-deadline">
                    <mat-icon>event</mat-icon>
                    <span>{{form.deadline ? form.deadline : '-'}}</span>
                </mat-card-subtitle>
            </div>

            <div class="public-form-body">
                <p class="public-form-description">
                    {{ form.description | slice:0:80 }}{{form.description.length > 80 ? '...' : ''}}
                </p>
            </div>

            <div class="public-form-footer">
                <button (click)="displayPublicForm(form)" mat-flat-button class="view-btn">
                    <mat-icon>visibility</mat-icon>
                    Προβολή
                </button>
            </div>
        </div>
    </div>

    <!--    <div fxFlex="grow" fxLayout="row" fxLayoutAlign="center center center" style="padding: 15px;-->
    <!--     border-radius: 5px;  background-color: var(&#45;&#45;secondaryBlue); color: white; margin-bottom:10px; width: 100%; font-size: 16px;">-->
    <!--        Ιστορικό δηλώσεων-->
    <!--    </div>-->

    <!--    <div #history *ngIf="!loadingChildren">-->
    <!--    <mat-expansion-panel  class=" mat-elevation-z0" expanded="true">-->
    <!--        <mat-expansion-panel-header class="panel">-->
    <!--            <mat-panel-description>-->

    <!--            </mat-panel-description>-->
    <!--        </mat-expansion-panel-header>-->
    <!--        <app-completed-consents [user]="user" [children]="children"></app-completed-consents>-->
    <!--    </mat-expansion-panel>-->
    <!--    </div>-->

    <div *ngIf="loadingChildren" class="skeleton-card">
        <div fxLayout="column" fxFlex="grow">
            <div fxLayout="row" fxFlex="grow">
                <ngx-skeleton-loader fxFlex="30" count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
            <div fxLayout="row" fxFlex="grow">
                <ngx-skeleton-loader fxFlex count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
            <div fxLayout="row" fxFlex="grow">
                <ngx-skeleton-loader fxFlex="grow" count="1" animation="progress"
                                     [theme]="{ width: '100%', height: '24px' }"></ngx-skeleton-loader>
            </div>
        </div>
    </div>
</div>
